<template>
	<v-container fluid v-if="configurando">
		<Configurando/>
	</v-container>
	<v-sheet v-else style="min-height: 100%">
		<v-main>
			<v-layout>
				<v-container>
					<v-fade-transition mode="out-in" appear>
						<router-view :emisor="emisor">
							<!-- Componente asociado a ruta -->
						</router-view>
					</v-fade-transition>
				</v-container>
			</v-layout>
		</v-main>
	</v-sheet>
</template>

<script>

import Configurando from './Configurando.vue';

import EmpresaSelector from '@/components/EmpresaSelector';
import MainNav from '@/components/MainNav';
import { Auth, API, Logger } from 'aws-amplify';

import CheckVersion from '@/components/CheckVersion';
import Mensajeria from '@/components/Mensajeria';

const HELP_URL = 'http://www.sii.cl/portales/boleta_electronica/index.html';
import { apiRefreshToken, apiSignin, apiSignInExternos } from '@/library/api/auth.js';
import { CredencialesSIImple } from '@/library/utils/externos/sistemaCredencialesExternas';

const logger = new Logger('SECCION EXTERNOS', 'ERROR')

const credenciales =  new CredencialesSIImple()

export default {
	components:{
		EmpresaSelector,
		MainNav,
		CheckVersion
		,Mensajeria
		,Configurando
	},
	computed: {
		showOverlay () {
			return !this.$store.getters['empresas/seleccionada'] && 
				this.$store.getters['empresas/lista'].length<=0;
		},
		noTieneEmisores(){
			return this.$store.getters['empresas/lista'].length<=0;
		}
		,estaConfigurado(){	return this.estadoConfig === 'CONFIGURADO'	}
		,configurando(){	return !this.estaConfigurado	}
	},
	data() {
		return {
			emisor: undefined,
			toggleMini: false,
			displayConfirm: false,
			helpUrl: HELP_URL,
			unsubscribe: undefined,
			estadoConfig: undefined,
		};
	},
	methods: {
		onCerrarSesionEvt: function(evt){
			this.displayConfirm = true;
		},
		cerrarSesion: async function() {
			let vm = this;

			let signout = await vm.$store.dispatch('usuario/signOut')


			if( !signout )
				vm.$router.push({name: 'inicio'});
		},
		goToHelp: function(){
			// TODO descomentar esta linea en caso de que SII comparta la url
			// para redireccionar. UTILIZAR LA CONSTANTE "HELP_URL"
			window.location.replace(this.helpUrl);
		},
		async onConfigurado(){
			this.$store.dispatch('empresas/getEmpresasExternos')
			this.estadoConfig = 'CONFIGURADO'
			await Promise.all([
				, this.$store.dispatch('app/getConfig')
			])
		}
	},
	async mounted() {

		this.estadoConfig = 'INICIANDO'

		try{
			logger.info('MOUNTING LAYOUT', this.$route.query)
			let user = await Auth.currentAuthenticatedUser()
			// this.estadoConfig = 'CONFIGURADO'
			logger.info('USUARIO LOGEADO', user)
			logger.info('cookie::', document.cookie)
		}catch(e){
			logger.warn('USUARIO POSIBLEMENTE NO LOGEADO', e)
			this.estadoConfig = 'NO_CONFIGURADO'
			try{

				let r = await apiSignInExternos(this.$route.query.sesion)
				logger.info('signin',r)
					//.then(r=>logger.info('signin',r)).catch(e=>logger.error('signin', e))

				const expires_at = new Date().getTime() + r.user.expires_in
				let authPayload = {
					token: r.openId.Token,
					identity_id: r.openId.IdentityId,
					expires_at
				}
				const user = {
					...r.user,
					expiresAt: expires_at
				}

				logger.info('Auth.federatedSignIn', authPayload)

				await credenciales.iniciarSesion( authPayload, user )
				// this.estadoConfig = 'CONFIGURADO'
				logger.info('creds', r);
			}catch(e){
				logger.error('signin', e)
				this.estadoConfig = 'ERROR'
			}
		}

		if( this.estadoConfig != 'ERROR' ){
			// await this.$store.dispatch('empresas/getEmpresasExternos');
			// await this.getConfig
			await this.onConfigurado()
		}
	},
	watch: {
	},
};
</script>
